import { FunctionComponent } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { DefaultRoutes, RouteSegments, useClientPageVisibility } from '@cbridge-packages/routing-client-admin';

/**
 * Reports are trading data: hidden without the basicBridge feature. Conversion rates stay available to a
 * standalone-markout tenant under Dashboards, so their old Reporting URL redirects there (LB-4724).
 */
export const ReportingGuard: FunctionComponent = () => {
  const { isTradingVisible } = useClientPageVisibility();
  const { pathname } = useLocation();

  if (isTradingVisible) {
    return <Outlet />;
  }

  const isConversionRates = pathname.endsWith(`/${RouteSegments.Reporting.ConversionRates}`);

  return (
    <Navigate
      to={isConversionRates ? `/${RouteSegments.Root.Dashboard}/${RouteSegments.Dashboards.ConversionRates}` : DefaultRoutes.Index}
      replace={true}
    />
  );
};
